import "reactflow/dist/style.css";
import { Stack } from "@altimateai/lego";
import { Label, Typography, Input } from "@altimateai/lego";
import styles from "./styles.module.scss";
import { CLL } from "../cllUtils";
import { CustomInput } from "./Form";
import { useLineageContext, useLineageDispatch } from "../context/LineageProvider";
import { setDefaultExpansion, setNonSelectCheck, setSelectCheck } from "../context/LineageSlice";
import { persistLineageSettings } from "../api";

function Settings({ applyDefault }: { applyDefault: (v: number) => void }) {
  const {
    state: { selectCheck, nonSelectCheck, defaultExpansion, aiEnabled },
  } = useLineageContext();
  const lineageDispatch = useLineageDispatch();

  return (
    <Stack className="al-p-2 al-h-full" direction="column">
      <Typography variant="h4">Settings</Typography>
      <Stack direction="column">
        <div>
          <Label htmlFor="default-expansion" className="fs-6 mb-1">
            Default Expansion
          </Label>
          <CustomInput
            id="default-expansion"
            value={defaultExpansion}
            type="number"
            onChange={e => {
              const value = Math.max(parseInt(e.target.value), 0);
              lineageDispatch(setDefaultExpansion(value));
              persistLineageSettings({ defaultExpansion: value });
              applyDefault(value);
            }}
          />
        </div>
        {aiEnabled && (
          <>
            <div className="fs-6">Edges visibility</div>
            <div className={styles.select_node_checkbox}>
              <Input
                type="checkbox"
                id="select-check"
                className="mt-2"
                checked={selectCheck}
                onChange={e => {
                  if (CLL.inProgress) {
                    CLL.showCllInProgressMsg();
                    return;
                  }
                  lineageDispatch(setSelectCheck(e.target.checked));
                  persistLineageSettings({
                    showSelectEdges: e.target.checked,
                  });
                }}
              />
              <Stack direction="column">
                <Label htmlFor="select-check" className="fs-6">
                  Select
                </Label>
                <div className="text-grey">
                  Select linkages are shown if there is direct flow of data between columns through
                  select statements.
                </div>
              </Stack>
            </div>
            <div className={styles.non_select_node_checkbox}>
              <Input
                type="checkbox"
                id="non-select-check"
                className="mt-2"
                checked={nonSelectCheck}
                onChange={e => {
                  if (CLL.inProgress) {
                    CLL.showCllInProgressMsg();
                    return;
                  }
                  lineageDispatch(setNonSelectCheck(e.target.checked));
                  persistLineageSettings({
                    showNonSelectEdges: e.target.checked,
                  });
                }}
              />
              <Stack direction="column">
                <Label htmlFor="non-select-check" className="fs-6">
                  Non-Select
                </Label>
                <div className="text-grey">
                  Non-Select linkages are shown if columns appear in condition/clauses like where,
                  join, having, etc.
                </div>
              </Stack>
            </div>
          </>
        )}
      </Stack>
    </Stack>
  );
}

export { Settings };
